import PropTypes from 'prop-types';
import React from 'react';
import api from './../../../api/Common.api';
import utils from './../../../utils/utilities';
import commonActions from './../../../api/Common.actions';

class UploadsPending extends React.Component {

    static propTypes = {
        pendingUpload: PropTypes.object
    };

    static defaultProps = {
        pendingUpload: {
            count:    0,
            uploadId: null
        }
    };

    componentDidMount() {
        api.getPendingUpload()
            .then((response) => {
                commonActions.updatePendingUploads(response);
            })
            .catch((error) => {
                utils.logError(error, 'api.getPendingUpload(): ');
            });
    }

    render() {
        return (
            <span>
                {
                    !!this.props.pendingUpload.count && this.props.pendingUpload.count !== 'N/A' ?
                        <span className='pending-uploads-indicator'>
                            {this.props.pendingUpload.count >= 100 ? '99+' : this.props.pendingUpload.count}
                        </span>
                        :
                        null
                }
            </span>
        )
    }

}

export default UploadsPending;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/templates/Header.uploadsPending.jsx